import { useMap, Marker, Popup, Tooltip } from "react-leaflet";
import { useEffect, useState, useCallback,useRef } from "react";
import omnivore from "@mapbox/leaflet-omnivore";
import ApiService from "../../services/apiService";
import ChackComponent from "./ChackComponent";
import { Button, Modal } from "reactstrap";
import L from 'leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { usePagination } from "../../hooks/usePagination";
import RightIcon from "../svg/RightIcon";
import LeftIcon from "../svg/LeftButton";
import ProgressBar from "./ProgressBar";
import ChackOnOf from "./ChackOnOf";
import { format } from "date-fns";
 

const ChildOms = ({ id }: { id: any }) =>{
     
    const map = useMap();
    const permanentTooltipRef = useRef<any>(null);
    const kmlLayersRef = useRef<L.Layer[]>([]);

    const [chackData, setChackData] = useState<any[]>([]);
    // Add these states at the top of your component
    const [isOpen, setIsOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [kmlUrls, setKmlUrls] = useState([]);
    const [isProgressBar, setIsProgressBar] = useState<boolean>(false);
    const [selectedOmsOrAms, setSelectedOmsOrAms] = useState<string>('')
    const [allenabled, setAllEnabled] = useState<boolean>()
    const [omsEnabled, setOmsEnabled] = useState<string>()
    const [amsEnabled, setAmsEnabled] = useState<string>()
    const [isActiveo, setIsActiveo] = useState<boolean>(false)
    const [isActivea, setIsActivea] = useState<boolean>(false)
    const [isActivep,setIsActivep] = useState<boolean>(false)
    const [hoveredId, setHoveredId] = useState<number | null>(null);
    const [selectedApi,setSelectedApi] = useState<string>('')
    const [onlineFilter, setOnlineFilter] = useState<'all' | 'online' | 'offline'>('all');
    const [isActived, setIsActived] = useState<boolean>(false);
    const getCustomMarker = (onValves: any, highlight: boolean = false) => {

        const color = onValves == null || onValves === 0 ? '#F7374F' : '#89AC46';
        const className = highlight ? 'circle-marker glow' : 'circle-marker';
        return L.divIcon({
          className: '', // Prevent default Leaflet styles
          html: `<div class="${className}" data-color="${color}"></div>`,
          iconSize: [20, 28],
          iconAnchor: [10, 28],
    
        });
    
      }

    

      // 3. Add this filter function (same pattern as KmLLayer)
      const filterOnlineOffline = (data: any) => {
        if (onlineFilter === 'online') {
          const diff = (new Date().getTime() - new Date(data.dateTime).getTime()) / (1000 * 60 * 60);
          if (diff > 24) return false;
        } else if (onlineFilter === 'offline') {
          const diff = (new Date().getTime() - new Date(data.dateTime).getTime()) / (1000 * 60 * 60);
          if (diff <= 24) return false;
        }
        return true;
      };
      const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy,
        setDeviceType, deviceType,
     
      } = usePagination({
        endpoint: `/chack/getchildchak`,
        enabled: true,
        pageSize:150
    
      })
    
    
      const totalPages = Math.ceil(totalCount / pageSize);
    
     
    
    
      useEffect(() => {
        if (!data || data.length === 0) return;
    
        setIsProgressBar(true);
        let isMounted = true;
        // ✅ Append new page data only

        if (isMounted) {
        setChackData(prevData => [...prevData, ...data]);
        }
        // ✅ Stop loading when full list is fetched
        if (chackData.length + data.length >= totalCount) {
          const stopTimer = setTimeout(() => {
            if (isMounted) setIsProgressBar(false);
          }, 1);
          return () => clearTimeout(stopTimer);
        }
    
        // ✅ Auto-fetch next page after 1s
        const timer = setTimeout(() => {
            if (isMounted) setPageNumber(prev => prev + 1);
        }, 1);
    
        return () => {
            isMounted = false; // cancel further updates
            clearTimeout(timer);
          };
      }, [data]);
    
      useEffect(() => {
        const getKml = async () => {
          try {
            const response = await ApiService.axiosApi("/kml", {
              method: "GET",
            });
            if (response.success) {
    
              setKmlUrls(response.data.data);
            } else {
              console.log(response.message || "Unable to get KML data");
            }
          } catch (error: any) {
            console.log(error);
          }
        };
    
        getKml();
      }, []);

      useEffect(() => {
        if (kmlUrls.length === 0) return; // If no KML URLs, skip
    
        // Function to load all KML files onto the map
        const loadKmlLayers = () => {
          kmlUrls.forEach((kmlObj: any) => {
            // Extract filePath from each object
            const kmlUrl = kmlObj.filePath;
    
            // Check if kmlUrl is a valid string
            if (typeof kmlUrl !== "string") {
              console.error(`Invalid KML URL: ${kmlUrl}`);
              return;
            }
    
            // Log the URL to ensure it's correct
    
    
            const kmlLayer = omnivore.kml(kmlUrl).on("ready", function(this: any) {
    
    
    
              function styleLayer(layer: L.Layer, parentName = '') {
                // If this is a Polyline
                if (layer instanceof L.Polyline) {
                  // Try to safely get the name from feature.properties
                  let name = parentName;
                  const feature = (layer as any).feature;
                  if (feature && 'properties' in feature && feature.properties?.name) {
                    name = feature.properties.name;
                  }
          
                  const lowerName = name.toLowerCase();
                  let lineColor = '#07e2fa';
                  if (lowerName.includes('main')) lineColor = '#FF0000';        // red
                  if (lowerName.includes('distributary')) lineColor = '#ff00ff'; // pink
          
                  layer.setStyle({ color: lineColor });
                 
          
                } else if (layer instanceof L.LayerGroup) {
                  // Pass down the parent name for MultiGeometry
                  let groupName = parentName;
                  const feature = (layer as any).feature;
                  if (feature && 'properties' in feature && feature.properties?.name) {
                    groupName = feature.properties.name;
                  }
          
                  layer.eachLayer(inner => styleLayer(inner, groupName));
                }
              }
          
          
          
              this.eachLayer(styleLayer);
              // Get the bounds of the KML layer and fit the map
              const bounds = kmlLayer.getBounds();
              map.fitBounds(bounds); // Adjust the map to fit the KML content
            });
    
            // Handle error if loading KML fails
            kmlLayer.on("error", (e: any) => {
              console.error("Error loading KML:", e);
            });
    
            map.addLayer(kmlLayer); // Add the KML layer to the map
          });
        };
    
        loadKmlLayers();
    
        // Cleanup layers on component unmount
        return () => {
            kmlLayersRef.current.forEach(layer => map.removeLayer(layer));
    kmlLayersRef.current = [];
        };
      }, [map, kmlUrls]);
      const filterDeviceType = (data: any) => {
        if (!isActiveo && !isActivea && !isActived) return true;
        if (isActiveo && isActivea && isActived) return false;
        if (isActiveo && !isActivea && !isActived) return data.deviceType === "AMS" || data.deviceType === "DMS";
        if (isActivea && !isActiveo && !isActived) return data.deviceType === "ROMS" || data.deviceType === "DMS";
        if (isActived && !isActiveo && !isActivea) return data.deviceType === "ROMS" || data.deviceType === "AMS";
        if (isActiveo && isActivea && !isActived) return data.deviceType === "DMS";
        if (isActivea && isActived && !isActiveo) return data.deviceType === "ROMS";
        if (isActiveo && isActived && !isActivea) return data.deviceType === "AMS";
        return false;
      };

    return(
         <>
            <MarkerClusterGroup>
        {chackData
          .filter(filterOnlineOffline) 
          .filter(filterDeviceType)  
      
          .map((data: any) => (
              <>
           

            <Marker key={data.id} position={[data.lat , data.long ]}

              eventHandlers={{
                click: () => {
                  setSelectedId(data.id);

                  if (data.deviceType === 'DMS') {
                    setIsOpen(true);
                  }
                  
                },
                
                 
              }}

              icon={getCustomMarker(data.onValves, id == data.id)}
            >
              {/* <Tooltip
    permanent
    direction="top"
    offset={[0, -15]}
    className="node-label"
    // unique attribute to re-select later
    pane="tooltipPane"
    // give each tooltip a unique data-id
    data-id={data.id}
    ref={permanentTooltipRef}
    interactive={false}
  >
    {data.chackName}
  </Tooltip> */}

  {/* Big tooltip only while hovered */}
  {
    <Tooltip
      sticky
      className={`${data.deviceType == 'AMS'? 'small-tooltip':'big-tooltip'}`}
     
    >  { 
        data.deviceType == 'AMS'?

        <table className="table-striped" style={{ width:'100%', height: '100%' }}>
           <tbody>
           <tr><th>AMS No.</th><td>{data.chackName}</td></tr>
          <tr><th>Distributary/Zone</th><td>{data.distributary_Zone}</td></tr>
          <tr><th>Pressure</th><td>{data.pressure}</td></tr>
           </tbody>
         </table>
      :
      <table className="table-striped" style={{  width:'100%', height: '100%',border:'1px solid whitesmoke' }}>
      <tbody>
        <tr><th>Chak</th><td>{data.chackName}</td></tr>
        <tr><th>Type</th><td>{data.deviceType}</td></tr>
        <tr><th>Open/Close</th><td>{data.valveOpen == true? 'Open':data.valveClosed == true ? "Closed" :"Closed"}</td></tr>
        <tr><th>Date&Time</th><td>{format(data.dateTime,'yyyy-MM-dd HH:mm:ss') }</td></tr>
      </tbody>
    </table> 
         
      
      }
    </Tooltip>
  }



            </Marker>
            </>
          ))}
      </MarkerClusterGroup>

      
      <MarkerClusterGroup>
  {chackData
    .filter(filterOnlineOffline)
    .filter(filterDeviceType)
    .map((data: any) => (
      <Marker
        key={data.id + "-label"}
        position={[data.lat + 0.000035, data.long + 0.0000]}
        icon={L.divIcon({ className: '' })}
      >
        <Tooltip permanent direction="top" className="node-label" interactive={false}>
          {data.chackName}
        </Tooltip>
      </Marker>
    ))
  }
</MarkerClusterGroup>




      {isOpen &&
 selectedId &&
  (
  <>
    {isOpen && selectedId && ( <Modal isOpen={isOpen } size='xl' centered> <ChackComponent id={selectedId} onClose={() => setIsOpen(false)} selectedChildOms={'childoms'}/> </Modal> )}
  </>
)}
      <div
        style={{
          position: 'absolute',
          top: '40px',
          right: '20px',
          backgroundColor: 'whitesmoke',
          padding: '10px',
          borderRadius: '8px',
          boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
          zIndex: 1000,
        }}
      >
       
      </div>




      {isProgressBar && <ProgressBar totalpage={totalPages} pageNumber={pageNumber} mystyle={{
        width: '300px',
        height: '50px',
        position: 'absolute',
        bottom: 100,
        right: 20,
        zIndex: 1000,
        backgroundColor: 'whitesmoke',
        borderRadius: '4px'
      }} />}
<div style={{
  position: 'absolute',
  top: '40px',
  right: '20px',
  backgroundColor: 'whitesmoke',
  padding: '10px',
  borderRadius: '8px',
  boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
  zIndex: 1000,
}}>
  <ChackOnOf
    chackData={chackData}
    onFilterChange={setOnlineFilter}
    filterDeviceType="DMS"
  />
</div>

      
    </>
         
        
    )
}

export default ChildOms;